(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-additions/assets/javascripts/coupon-additions.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-additions/assets/javascripts/coupon-additions.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useComponentFromRegistry = svs.components.tipsen.componentRegistry.useComponentFromRegistry;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.engineSelectors,
  selectSportkryssFactors = _svs$components$tipse.selectSportkryssFactors,
  selectWeeks = _svs$components$tipse.selectWeeks,
  selectBetAmounts = _svs$components$tipse.selectBetAmounts;
const isMarketplaceWallet = svs.components.tipsen.wallet.walletHelpers.isMarketplaceWallet;
const WALLET_ID_PLAYER = svs.components.tipsen.wallet.walletId.WALLET_ID_PLAYER;
const _svs$components$tipse2 = svs.components.tipsen.wallet.walletType,
  WALLET_SELFSERVICE = _svs$components$tipse2.WALLET_SELFSERVICE,
  WALLET_MARKETPLACE_RETAILER = _svs$components$tipse2.WALLET_MARKETPLACE_RETAILER;
const _svs$components$tipse3 = svs.components.tipsen.walletSelectors,
  selectActiveWallet = _svs$components$tipse3.selectActiveWallet,
  useWallets = _svs$components$tipse3.useWallets;
const _svs$components$tipse4 = svs.components.tipsen.walletComponent,
  WalletComponent = _svs$components$tipse4.WalletComponent,
  WalletAddition = _svs$components$tipse4.WalletAddition;
const selectIsSportkryssSupported = svs.components.tipsen.engine.selectors.couponSelectors.selectIsSportkryssSupported;
const _svs$components$tipse5 = svs.components.tipsen.couponAdditionsComponents,
  Sportkryss = _svs$components$tipse5.Sportkryss,
  BetAmounts = _svs$components$tipse5.BetAmounts,
  AddonPix = _svs$components$tipse5.AddonPix;
const useDefinition = svs.components.tipsen.engine.utils.useDefinition;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const feature = svs.core.detect.feature;
const productIds = svs.utils.products.productIds;
const hasMarketplaceMultipleWeeks = svs.core.detect.feature('ft-marketplace-multiple-weeks');
const CouponAdditions = _ref => {
  let _ref$hasWeeksEnabled = _ref.hasWeeksEnabled,
    hasWeeksEnabled = _ref$hasWeeksEnabled === void 0 ? true : _ref$hasWeeksEnabled,
    _ref$hasBetAmountEnab = _ref.hasBetAmountEnabled,
    hasBetAmountEnabled = _ref$hasBetAmountEnab === void 0 ? true : _ref$hasBetAmountEnab,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const Weeks = useComponentFromRegistry('coupon-multiple-additions');
  const couponId = useCouponId();
  const sportkryssFactors = useSelector(selectSportkryssFactors);
  const draw = useCurrentDraw();
  const productId = draw.productId;
  const isMultiDrawsDisabled = feature('ft-hvs-disable-multidraws');
  let weeks = useSelector(selectWeeks);
  if (productId === productIds.FULLTRAFF && isMultiDrawsDisabled) {
    weeks = [1];
  }
  const betAmounts = useSelector(selectBetAmounts);
  const wallet = useSelector(selectActiveWallet);
  const sportkryssSupported = useSelector(state => selectIsSportkryssSupported(state, couponId));
  const wallets = useWallets();
  const isSelfserviceWallet = wallet && WALLET_SELFSERVICE === wallet.type;
  const isMarketplaceRetailerWallet = wallet && WALLET_MARKETPLACE_RETAILER === wallet.type;
  const hasOnlyPlayerWallet = wallets.length === 1 && wallets[0].id === WALLET_ID_PLAYER;
  const isActiveMarketplaceWallet = isMarketplaceWallet(wallet);
  const hasMarketplaceSupport = isActiveMarketplaceWallet && !isMarketplaceRetailerWallet && hasMarketplaceMultipleWeeks;
  const shouldShowWeeks = !isActiveMarketplaceWallet || hasMarketplaceSupport;
  const showSportKryss = sportkryssFactors.length > 1 && sportkryssSupported;
  const showWeeks = weeks.length > 1 && shouldShowWeeks && hasWeeksEnabled;
  const showBetAmount = betAmounts.length > 1 && hasBetAmountEnabled;
  const showWallet = !isSelfserviceWallet && wallets.length > 0 && !hasOnlyPlayerWallet;
  const drawNumber = draw.drawNumber;
  const definition = useDefinition();
  const type = 'pix';
  const addonPixProductId = definition.getRelatedProduct(type, productId);
  const hasAddonPix = Boolean(!isActiveMarketplaceWallet && addonPixProductId);
  const shouldShowAdditions = showSportKryss || showWeeks || showBetAmount || showWallet;
  if (!shouldShowAdditions) {
    return null;
  }
  const classNames = ['tipsen-additions'];
  classNames.push(className);
  return React.createElement("section", {
    "aria-labelledby": "tipsen-additions-heading",
    className: classNames.join(' ')
  }, React.createElement("h2", {
    className: "tipsen-header f-center f-medium",
    id: "tipsen-additions-heading"
  }, "Tillval"), React.createElement("div", {
    className: "tipsen-additions-grid"
  }, showSportKryss && React.createElement(Sportkryss, null), showWeeks && React.createElement(Weeks, null), showBetAmount && React.createElement(BetAmounts, null), hasAddonPix && React.createElement(AddonPix, {
    drawNumber: drawNumber,
    pixProductId: addonPixProductId,
    productId: productId
  }), showWallet && React.createElement(WalletComponent, {
    Component: WalletAddition
  })));
};
setGlobal('svs.components.tipsen.couponAdditions.CouponAdditions', CouponAdditions);

 })(window);